/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as API from '../../http/api';
import { FormGroup, FormControlLabel, FormControl, InputLabel, Grid, InputAdornment, Divider, Switch, Typography, Tooltip, IconButton, TextField, Paper, MenuItem, Select } from '@mui/material';
import { People, Edit, Delete, GroupAdd, Search, FormatListBulleted } from '@mui/icons-material';
import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { openlightbox } from '../../util/Functions';
import * as MODALS from '../modals';
import DataTable from 'react-data-table-component';
import { ThemeProvider } from '@mui/material/styles';
import { theme, customStyles } from '../../util/TableStyles';
import { noDataComponent, rolesType } from "../../util/DataObject";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { JsonToCsv } from '../../util/JsonToCsv';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		titlesTabs: {
			textRendering: "geometricPrecision",
			WebkitFontSmoothing: "antialiased !important",
			scrollBehavior: "smooth",
			fontFamily: "Muli,sans-serif !important",
			color: "#969BA0 !important",
			//fontWeight: 'bold'
		},
		contentTab: {
			padding: "10px !important",
		},
		firstTitle: {
			padding: "16px",
		},
		titleTable: {
			display: "flex",
			width: "100%",
		},
		buttonAdd: {
			marginLeft: "88% !important",
		},
		titleH2: {
			display: "flex",
		},
		iconTitle: {
			marginTop: "4px",
			marginRight: "5px",
		},
		textField: {
			marginLeft: theme.spacing(1),
			display: "flex !important",
			width: "25% !important",
			margin: "auto !important",
			marginRight: "0 !important",
		},
	})
);

const AgentList = (props) => {
	const clasess = useStyles();
	const history = useHistory();
	const [list, setList] = useState([]);
	const [limit, setLimit] = useState(1);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(0);
	const [email, setEmail] = useState('');
	const [rol, setRol] = useState('');
	const [status, setStatus] = useState('');
	const [roles, setRoles] = useState([]);

	useEffect(() => {
		init();
	}, [props.content]);

	const init = () => {
		if(props.content.agents){
			setList(JSON.parse(JSON.stringify(props.content.agents)));
		}
		if(props.content.hasOwnProperty('limit')){
			setLimit(props.content.limit);
		}
		if(props.content.hasOwnProperty('page')){
			setPage(props.content.page);
		}
		if(props.content.hasOwnProperty('total')){
			setTotal(props.content.total);
		}
		if(props.content.roles){
			setRoles(props.content.roles);
		}
		if(props.content.rol){
			setRol(props.content.rol);
		}
		if(props.content.email){
			setEmail(props.content.email);
		}
	};

	const paginationComponentOptions = {
		rangeSeparatorText: 'de',
		rowsPerPageText: 'Registros por página',
	};

	const changePage = async (value) => {
		let data = {
			page: value,
			limit: limit,
			rol: rol,
			email: email
		}

		!status ? delete data['status'] : data['status'] = [status]

		await reloadData(data);
	};

	const changeTotal = async (e) => {
		let data = {
			page: 1,
			limit: e,
			rol: rol,
			email: email
		}
		setStatus('')
		await reloadData(data);
	};

	const updateAgentInfo = async (data) => {
		props.changeLoader(true);
		let request = await API.service("updateAgent", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
		}

		props.changeLoader(false);
	};

	const reloadData = async (data) => {
		props.changeLoader(true);
		let request = await API.service("admin", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
		}

		props.changeLoader(false);
	};

	const blockUnblock = async (flag, uuid) => {
		props.changeLoader(true);

		let data = {
			uuid: uuid,
		};
		if (flag == "enabled") {
			data["body"] = {
				status: "disabled",
			};
		}

		if (flag == "disabled") {
			data["body"] = {
				status: "enabled",
			};
		}

		data['page'] = page;
		data['limit'] = limit;
		data['rol'] = rol;
		data['email'] = email;

		await updateAgentInfo(data);
	};

	const createFormAgent = async (uuid) => {
		props.changeLoader(true);
		let data = {};
		if (uuid) {
			data["uuid"] = uuid;
		}

		let request = await API.service("formAgent", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			let widg = [];
			widg = request.data.data.widget;
			if (widg[0].type == "formAgent" && widg[0].content) {
				const as = <MODALS.FormAgent
					pos={props.pos}
					changeAlert={props.changeAlert}
					changeLoader={props.changeLoader}
					contentModal={widg[0]?.content}
					reloadData={reloadData}
					key="formAgent"
				/>
				openlightbox(as);
			}
		}
		props.changeLoader(false);
	};

	const signatureAdmin = async () => {
		props.changeLoader(true);
		let data = {
			authSignature: true
		};

		let request = await API.service("agentAuthSignature", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			let content = request.data.data.content;
			props.changeLoader(false);
			const as = <MODALS.SignatureAdmin
				open={true}
				data={content}
				changeAlert={props.changeAlert}
				changeLoader={props.changeLoader}
			/>
			openlightbox(as);
		}
	};

	const openModal = (uuid, email) => {
		let modal = {
			uuid: uuid,
			email: email,
		};
		const as = <MODALS.DeleteAgent
			pos={props.pos}
			changeAlert={props.changeAlert}
			changeLoader={props.changeLoader}
			contentModal={modal}
			deleteUser={deleteUser}
			key="deleteAgent"
		/>
		openlightbox(as);
	};

	const deleteUser = async (uuid) => {
		props.changeLoader(true);
		let data = {};
		if (uuid) {
			data["uuid"] = uuid;
		}

		let request = await API.service("deleteAgent", data, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			await reloadData({});
		}

		props.changeAlert(true, "success", "Agente eliminado con éxito");
		props.changeLoader(false);
	};

	const columns = [
		{ selector: (row) => row.name, name: "Nombre", width:"25%", wrap: true, sortable: true },
		{ selector: (row) => row.email, name: "Email", width:"20%", wrap: true, sortable: true },
		{
			cell: (row) => {
				return <FormGroup>
					{ row.status == 'enabled' && 
						<FormControlLabel
							control={
								<Switch
									defaultChecked={row.status == 'enabled' ? true : false}
									onChange={blockUnblock.bind(this, row.status, row.uuid)}
								/>
							}
							label={row.status == 'enabled' ? 'Activo' : ((row.status == 'disabled') ? 'Inactivo' : 'N/A')}
						/>
					}
					{ row.status == 'disabled' && 
						<FormControlLabel
							control={
								<Switch
									defaultChecked={row.status == 'enabled' ? true : false}
									onChange={blockUnblock.bind(this, row.status, row.uuid)}
								/>
							}
							label={
								row.status == 'enabled' ? 'Activo' : 
								((row.status == 'disabled') ? 'Inactivo' : 'N/A')
							}
						/>
					}
				</FormGroup>
			}, name: 'Estatus', width: '20%'
		},
		{ selector: (row) => row.rolName, name: "Rol", width:"20%", wrap: true, sortable: true },
		{
			cell: (row) => {
				return <Typography fontWeight="400" fontFamily="Muli,sans-serif" color="#000000de" fontSize="0.875rem">
					<Tooltip title='Editar'>
						<IconButton onClick={createFormAgent.bind(this, row.uuid)}>
							<Edit/>
						</IconButton>
					</Tooltip>
					<Tooltip title='Borrar'>
						<IconButton onClick={openModal.bind(this, row.uuid, row.email)}>
							<Delete/>
						</IconButton>
					</Tooltip>
				</Typography>
			}, name: 'Acciones', width: '15%'
		}
	];

	const changeValue = async (field, e) => {
        let r = rol;
        let em = email;
        if(field == 'rol'){
            r = e.target.value;
            setRol(r);
			let data = {
				page: 1,
				limit: limit,
				email: em,
				rol: r
			}
            
            if(!em){
                delete data.email;
            }
    
            if(!r){
                delete data.rol;
            }
    
            await reloadData(data);
        }

		if(field == 'status'){
            var s = e.target.value;
			let data = {
				page: 1,
				limit: limit,
				email: em
			}
			
			setStatus(s)
			
			!s ? delete data['status'] : data['status'] = [s];

            if(!em){
                delete data.email;
            }
            if(rol){
             	data["rol"] = rol;
            }
            await reloadData(data);
        }

        if(field == 'email'){
            em = e.target.value.trim();
            setEmail(em);
        }
        
    }

	const findEmail = async () => {
        let r = rol;
        let em = email;

        
		let data = {
			page: 1,
			limit: limit,
			email: em,
			rol: r
		}

        if(!em){
            delete data.email;
        }

        if(!r){
            delete data.rol;
        }

        await reloadData(data);
    }
	
	const downloadReport = async () => {
		props.changeLoader(true);

		let payload = 'enabled'

		let enabledAgents = []
		let columns = [];

		let request = await API.service("agentByStatusList", payload, props.pos, props.changeAlert, props.changeLoader, history);
		if (request.status == 200 && request.data.data.response == "OK") {
			enabledAgents = request.data.data.content
		}


		columns.push(
			{ header: "N°", key: "num", width: 5, style: {alignment: {vertical: "middle", horizontal: "center"}} },
			{ header: "Agente", key: "name", width: 40, style: {alignment: {vertical: "middle"}} },
			{ header: "Email", key: "email", width: 40, style: {alignment: {vertical: "middle"}} },
		);
		rolesType.map((role) => {
			columns.push({ header: role.value, key: role.key, comment: role.label, style: {alignment: {horizontal: "center", vertical: "middle"}} })
		})

		let newList = enabledAgents.map((item, index) => {
			item['num'] = index + 1
			if(item['allRoles']){
				rolesType.map((role) => {
					item['allRoles'].includes(role.key) ? item[role.key] = "X" : item[role.key] = "---"
				})
			}
			if(item['roles']){
				rolesType.map((role) => {
					item['roles'].includes(role.key) ? item[role.key] = "X" : item[role.key] = "---"
				})
			}
			return item
		});

		let fileName = `reporte-agentes`

		let specialCells = {
			iconRef: `C2:R${newList.length + 1}`,
			rules: [
				{
					type: 'expression',
					formulae: ['C2="X"'],
					priority: 0,
					style: { font: { color: { argb: '38761D' }, bold: true, alignment: { horizontal: 'center', vertical: 'middle' } }}
				},
				{
					type: 'expression',
					formulae: ['C2="---"'],
					priority: 0,
					style: { font: { color: { argb: '1D6976' }, bold: true, alignment: { horizontal: 'center', vertical: 'middle' } }}
				}
			]
		}

		JsonToCsv(newList, columns, fileName, specialCells, null, true)
		props.changeLoader(false);
	}

	return <Paper sx={{ width: "100%", padding: "2vw" }}>
		<Typography
			component="div"
			children={
				<div className={clasess.titleTable} style={{placeContent: "space-between"}}>
					<h2 className={clasess.titleH2}>
						<People className={clasess.iconTitle} />
						Agentes
					</h2>
					<div>
						<Tooltip title="Firma Autorizada">
							<IconButton onClick={signatureAdmin.bind(this, "")} sx={{padding: "0 !important", height: 40, mr: 1}}><FingerprintIcon sx={{padding: 1, borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#79c1b7", height: "-webkit-fill-available" }}/></IconButton>
						</Tooltip>
						<Tooltip title="Agregar agente">
							<IconButton onClick={createFormAgent.bind(this, "")} sx={{padding: "0 !important", height: 40, mr: 1}}><GroupAdd sx={{padding: 1, borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179", height: "-webkit-fill-available" }}/></IconButton>
						</Tooltip>
						<Tooltip title="Descargar listado">
							<IconButton onClick={downloadReport.bind(this, "")} sx={{padding: "0 !important", height: 40}}><FormatListBulleted sx={{padding: 1, borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#c17979", height: "-webkit-fill-available" }}/></IconButton>
						</Tooltip>
					</div>
				</div>
			}
			fontWeight="bold"
			fontFamily="Muli,sans-serif"
			fontSize="20px"
		/>

		<Grid container spacing={2} sx={{marginBottom: '2%'}}>
			<Grid item xs={4} display={'flex'} sx={{pl: '1%'}}>
				<FormControl fullWidth color='secondary' sx={{mr: 2}}>
					<InputLabel id='select-rol'>Rol</InputLabel>
					<Select labelId='select-rol' color='secondary' value={rol} onChange={changeValue.bind(this, 'rol')}>
						<MenuItem value={''}>Todos</MenuItem>
						{
							roles.map((item, index) => {
								return <MenuItem value={item.uuid} key={`item-rol-${index}`}>{item.name}</MenuItem>
							})
						}
					</Select>
				</FormControl>
				<FormControl fullWidth color='secondary'>
					<InputLabel id='select-status'>Estatus</InputLabel>
					<Select labelId='select-status' color='secondary' value={status} onChange={changeValue.bind(this, 'status')}>
						<MenuItem value={''}>Todos</MenuItem>
						<MenuItem value={'enabled'}>Activos</MenuItem>
						<MenuItem value={'disabled'}>Inactivos</MenuItem>
					</Select>
				</FormControl>
			</Grid>

			<Grid item xs={4}></Grid>

			<Grid item xs={4}>
				<FormControl fullWidth color='secondary'>
				<TextField
                  	label="Email" value={email} onChange={changeValue.bind(this, 'email')} fullWidth 
						InputProps={{
							endAdornment: <InputAdornment position='end'>
								<IconButton onClick={findEmail.bind(this)}>
									<Search/>
								</IconButton>
							</InputAdornment>
						}}
						/>
				</FormControl>
			</Grid>
		</Grid>
		<Divider/>


		<ThemeProvider theme={theme}>
          <DataTable
            columns={columns}
            data={list}
            //pagination={props.content.hasOwnProperty("userList") ? true : false}
            paginationComponentOptions={paginationComponentOptions}
            customStyles={customStyles}
			pagination
			paginationServer
			paginationTotalRows={total}
			onChangePage={changePage}
			paginationPerPage={props.content.limit}
			paginationRowsPerPageOptions={[5,10,20,30,40,50]}
			onChangeRowsPerPage={changeTotal}
			noDataComponent={noDataComponent}
          />
        </ThemeProvider>
	</Paper>
};

export default AgentList;